/** Returns controls for recording each scroll-depth threshold once between resets. */
export function createScrollDepthTracker() {
  let ticking = false;
  const scrollPercentages = new Map([
    [25, false],
    [50, false],
    [75, false],
    [100, false],
  ]);

  function resetScrollPercentages() {
    scrollPercentages.forEach((_, key) => scrollPercentages.set(key, false));
  }

  function trackScroll(percent) {
    scrollPercentages.forEach((seen, threshold) => {
      if (!seen && percent >= threshold) {
        scrollPercentages.set(threshold, true);
        document.dispatchEvent(new CustomEvent("scroll-depth.sparkle", { detail: { args: [threshold] } }));
      }
    });
  }

  function handleScroll() {
    const height =
      Math.max(document.documentElement.scrollHeight, document.body.scrollHeight) -
      document.documentElement.clientHeight;
    trackScroll((window.scrollY / height) * 100);
    ticking = false;
  }

  function queueScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(handleScroll);
    }
  }

  function startTracking() {
    document.addEventListener("scroll", queueScroll, { passive: true });
  }
  return Object.freeze({ resetScrollPercentages, trackScroll, startTracking });
}
